import React from 'react';
import InputSelect from '../../../../../../component/inputSelect/InputSelect';
import PageLoader from '../../../../../../component/PageLoader';

export default function General({ setForm, form, error, setError, generalLoader }) {
	const handleFormData = (key, value) => {
		setForm((prev) => ({
			...prev,
			[key]: value,
		}));
	};
	const list = [
		{ key: 'Flat', value: '₹ Flat' },
		{ key: 'discount', value: '% Discount' },
	];
	return (
		<div>
			{generalLoader.isLoader && generalLoader.isGetData ? (
				<PageLoader />
			) : (
				<div className="p-4">
					<div className="row align-items-center my-2">
						<div className="col-3 col-xl-2 text-sm font-medium text-start">
							Discount Preferences
						</div>
						<div className="col-8 col-xl-6 my-2">
							<InputSelect
								options={list}
								label=""
								placeholder="Select Discount Preferences"
								error={error?.industry_id}
								returnInputValue={false}
								value={form.discount_preferences}
								onChange={(value) => { }}
								onSelect={(options) => handleFormData('discount_preferences', options.key, true)}
							/>
						</div>
					</div>
					<div className="row align-items-center my-2">
						<div className="col-3 col-xl-2 text-sm font-medium text-start">Email Attachment</div>
						<div className="col-8 col-xl-6 my-2">
							<div className="form-check">
								<input
									class="form-check-input"
									type="checkbox"
									checked={form.email_attachments}
									id="flexCheckDefault"
									onChange={(e) => handleFormData('email_attachments', !form.email_attachments)}
								/>
							</div>
						</div>
					</div>
					<div className="row align-items-center my-2">
						<div className="col-3 col-xl-2 text-sm font-medium text-start">
							Round off Preferences
						</div>
						<div className="col-8 col-xl-6 my-2">
							<div className="d-flex gap-4 align-items-center">
								<label className="d-flex gap-3 py-2 cursor-pointer">
									<input
										type="radio"
										className="custom-radio"
										checked={form.round_off_preferences === 'up'}
										onChange={() => handleFormData('round_off_preferences', 'up')}
									/>
									{'Round Up'}
								</label>
								<label className="d-flex gap-3 py-2 cursor-pointer">
									<input
										type="radio"
										name="round"
										className="custom-radio"
										checked={form.round_off_preferences === 'down'}
										onChange={() => handleFormData('round_off_preferences', 'down')}
									/>
									Round Down
								</label>
							</div>
						</div>
					</div>
					<div className="row align-items-center my-2">
						<div className="col-3 col-xl-2 text-sm font-medium text-start">Enable Salesperson</div>
						<div className="col-8 col-xl-6 my-2">
							<div className="form-check">
								<input
									class="form-check-input"
									type="checkbox"
									checked={form.enable_sales_person}
									id="flexCheckDefault"
									onChange={(e) => handleFormData('enable_sales_person', !form.enable_sales_person)}
								/>
							</div>
						</div>
					</div>
					<div className="row align-items-center my-2">
						<div className="col-3 col-xl-2 text-sm font-medium text-start">
							Enable Auto Capitalize Input
						</div>
						<div className="col-8 col-xl-6 my-2">
							<div className="form-check">
								<input
									class="form-check-input"
									type="checkbox"
									checked={form.enable_auto_capitalize_input}
									id="flexCheckDefault"
									onChange={(e) =>
										handleFormData(
											'enable_auto_capitalize_input',
											!form.enable_auto_capitalize_input,
										)
									}
								/>
							</div>
						</div>
					</div>
					<div className="row align-items-center my-2">
						<div className="col-3 col-xl-2 text-sm font-medium text-start">
							Enable Quantity Edit on Purchase Bill
						</div>
						<div className="col-8 col-xl-6 my-2">
							<div className="form-check">
								<input
									class="form-check-input"
									type="checkbox"
									checked={form.enable_quantity_edit_on_purchase_bill}
									id="flexCheckDefault"
									onChange={(e) =>
										handleFormData(
											'enable_quantity_edit_on_purchase_bill',
											!form.enable_quantity_edit_on_purchase_bill,
										)
									}
								/>
							</div>
						</div>
					</div>
				</div>
			)}
		</div>
	);
}
